import { useNavigate } from "react-router-dom";

const CustomCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white">
      <div className="w-full px-6 lg:px-12">

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">常見問題</h2>
            <p className="text-gray-500">自訂行程的客人最常問我們的問題</p>
          </div>
          <div className="space-y-4">
            {[
              {
                q: "我完全沒有自駕中國的經驗，可以嗎？",
                a: "完全沒問題！超過 60% 的客人都是第一次自駕中國。我們的顧問會根據您的駕駛經驗推薦合適難度的路線，並全程安排有經驗的中文導遊在車上陪同，有任何狀況都能即時處理。",
              },
              {
                q: "行程確認後，途中可以更改計劃嗎？",
                a: "可以！只要提前通知我們，我們會協助調整住宿及路線安排。這正是自訂行程的優勢——靈活應變，不受固定行程束縛。",
              },
              {
                q: "最少幾個人才能出發？",
                a: "一個人也可以出發！自訂行程沒有最低人數要求，一人、二人小情侶遊、一家大小，我們都有豐富的接待經驗。",
              },
              {
                q: "費用大概是多少？",
                a: "費用因路線、天數、人數及住宿選擇差異較大。一般 2 人 8 天行程，跨境服務費約 HK$8,000–12,000 / 人（已包含所有跨境手續及全程導遊）。詳細報價請聯繫我們，48 小時內回覆。",
              },
            ].map((faq, i) => (
              <details key={i} className="group bg-stone-50 rounded-2xl border border-stone-100 open:border-orange-200 transition-all">
                <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                  <span className="font-semibold text-gray-900 text-sm pr-4">{faq.q}</span>
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 bg-white rounded-full border border-stone-200 group-open:bg-orange-500 group-open:border-orange-500 transition-all">
                    <i className="ri-add-line text-gray-500 group-open:text-white group-open:rotate-45 transition-all text-base"></i>
                  </div>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>

        {/* Final CTA */}
        <div className="relative overflow-hidden rounded-3xl">
          <img
            src="https://public.readdy.ai/ai/img_res/daf73eea6c9cdc1bd781eb50163bd5f6.jpg"
            alt="立即出發"
            className="w-full h-80 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <div className="inline-flex items-center gap-2 bg-orange-500 text-white rounded-full px-4 py-1.5 mb-5 text-sm font-semibold">
              <i className="ri-fire-line"></i>
              <span>自訂行程 · 全站最熱門</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              準備好出發了嗎？
            </h2>
            <p className="text-white/80 text-lg mb-8 max-w-lg">
              告訴我們您的夢想，24小時內專屬顧問主動聯繫您，完全免費諮詢
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="https://wa.me/85253482337?text=%E4%BD%A0%E5%A5%BD%EF%BC%8C%E6%88%91%E6%83%B3%E6%9F%A5%E8%A9%A2%E8%87%AA%E8%A8%82%E8%A1%8C%E7%A8%8B"
                target="_blank"
                rel="nofollow noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                <span>WhatsApp 即時查詢</span>
              </a>
              <button
                onClick={() => {
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                  }, 300);
                }}
                className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border border-white/40 px-8 py-4 rounded-full text-lg font-medium transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-send-line text-xl"></i>
                <span>填寫查詢表單</span>
              </button>
            </div>
          </div>
        </div>

        {/* Guarantees */}
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "ri-refresh-line", title: "無限次修改", desc: "方案確認前可無限次調整" },
            { icon: "ri-money-dollar-circle-line", title: "免費諮詢", desc: "規劃過程全程免費" },
            { icon: "ri-time-line", title: "24H 回覆", desc: "提交查詢後 24 小時內回覆" },
            { icon: "ri-shield-check-line", title: "透明報價", desc: "報價單清晰列明，無隱藏費" },
          ].map((g) => (
            <div key={g.title} className="bg-stone-50 rounded-2xl p-5 text-center border border-stone-100">
              <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                <i className={`${g.icon} text-orange-500 text-lg`}></i>
              </div>
              <h4 className="font-bold text-gray-900 text-sm mb-1">{g.title}</h4>
              <p className="text-gray-500 text-xs">{g.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CustomCTA;
